import type { Beneficiary } from '@evogard/contract';
import type {
  BeneficiaryAccountType,
  BeneficiaryRefType,
  PixKeyType,
} from '@evogard/domain';
import {
  BENEFICIARY_REF_TYPE_LABELS,
  COMPANY_TYPE_LABELS,
  INPUT_MASK_PLACEHOLDER,
  beneficiaryKindLabel,
} from '@evogard/domain';
import { BANKS } from './banks.js';

/**
 * Os rótulos do cadastro de beneficiário — o que a tela escreve no lugar do
 * valor gravado (`companhia`, `poupanca`, `aleatoria`).
 */

export const REF_TYPE_LABELS: Readonly<Record<BeneficiaryRefType, string>> =
  BENEFICIARY_REF_TYPE_LABELS;

/** Moram em `@evogard/domain`: a descrição da despesa no Conta Azul lê os mesmos. */
export { COMPANY_TYPE_LABELS };

// @valor
export const ACCOUNT_TYPE_LABELS: Readonly<Record<BeneficiaryAccountType, string>> = {
  corrente: 'Conta corrente',
  poupanca: 'Poupança',
};

// @valor
export const PIX_TYPE_LABELS: Readonly<Record<PixKeyType, string>> = {
  cpf: 'CPF',
  cnpj: 'CNPJ',
  email: 'E-mail',
  telefone: 'Telefone',
  aleatoria: 'Chave aleatória',
};

/** O exemplo dentro do campo da chave, conforme o tipo escolhido. */
// @valor
export const PIX_PLACEHOLDERS: Readonly<Record<PixKeyType, string>> = {
  cpf: INPUT_MASK_PLACEHOLDER.cpf,
  cnpj: INPUT_MASK_PLACEHOLDER.cnpj,
  email: 'financeiro@empresa.com.br',
  telefone: INPUT_MASK_PLACEHOLDER.phone,
  aleatoria: '123e4567-e89b-12d3-a456-426614174000',
};

/** "Oficina", "Associado" — o que a linha diz sobre QUEM é o dono. */
export function ownerKindLabel(
  b: Pick<Beneficiary, 'beneficiaryRefType' | 'owner'>,
): string {
  return beneficiaryKindLabel(b.beneficiaryRefType, b.owner.companyType ?? null);
}

/** O nome do banco pelo código, da lista do BACEN — ou o nome gravado, se o banco saiu dela. */
export function bankLabel(code: string | null, storedName: string | null): string | null {
  if (!code) return storedName;
  const bank = BANKS.find((b) => b.code === code);
  return `${code} · ${bank?.name ?? storedName ?? 'banco fora da lista do BACEN'}`;
}
